import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { TranslocoService } from '@jsverse/transloco';
import { HippoConfirmationService } from '@hippo/services/confirmation';

@Injectable({ providedIn: 'root' })
export class AutoLogoutService {
    private timeoutId: any;
    private readonly LOGOUT_TIME = 24 * 60 * 60 * 1000 - 1 * 60 * 1000; // 23h 59m

    constructor(
        private router: Router,
        private authService: AuthService,
        private translocoService: TranslocoService,
        private hippoConfirmationService: HippoConfirmationService
    ) {}

    startTimer(): void {
        this.clearTimer();
        this.timeoutId = setTimeout(() => {
            // Subscribe: signOut() also drops this session's data in PHP, and
            // an unsubscribed request is never sent (HIP-62).
            this.authService.signOut().subscribe();
            this.clearTimer();
            this.router.navigate(['/sign-in']);
            const message =
                this.translocoService.getActiveLang() === 'de'
                    ? 'Ihre Sitzung ist abgelaufen. Sie wurden ausgeloggt. Bitte loggen Sie sich wieder ein.'
                    : 'Your session has expired. You have been logged out. Please log in again.';
            const confirmation = this.hippoConfirmationService.open({
                title: 'Information',
                message,
                icon: { show: true, color: 'info' },
                actions: {
                    confirm: {
                        label: 'OK',
                        color: 'primary',
                    },
                    cancel: {
                        show: false,
                    },
                },
                dismissible: false,
            });
        }, this.LOGOUT_TIME);
    }

    resetTimer(): void {
        this.startTimer();
    }

    clearTimer(): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }
}
